import "./SideNav.scss"; // Import the styling
//Material UI imports
import * as React from "react";
import List from "@mui/material/List"; // Import List component from Material-UI
import ListItem from "@mui/material/ListItem"; // Import ListItem component from Material-UI
import ListItemButton from "@mui/material/ListItemButton"; // Import ListItemButton component from Material-UI
import ListItemIcon from "@mui/material/ListItemIcon"; // Import ListItemIcon component from Material-UI
import ListItemText from "@mui/material/ListItemText"; // Import ListItemText component from Material-UI
import AccessTimeIcon from "@mui/icons-material/AccessTime"; // Import AccessTimeIcon from Material-UI icons
import HistoryIcon from "@mui/icons-material/History"; // Import HistoryIcon from Material-UI icons
import GrassIcon from "@mui/icons-material/Grass";
import WaterIcon from "@mui/icons-material/Water";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"; // Import AddCircleOutlineIcon from Material-UI icons
import Collapse from "@mui/material/Collapse";
import DevicesIcon from "@mui/icons-material/Devices"; // Import Collapse component from Material-UI
import { ExpandLess } from "@mui/icons-material"; // Import ExpandLess icon from Material-UI icons
import { ExpandMore } from "@mui/icons-material"; // Import ExpandMore icon from Material-UI icons
import CropSquareIcon from "@mui/icons-material/CropSquare"; // Import CropSquareIcon from Material-UI icons
import { useMediaQuery } from "@mui/material"; // Import hook for screen size

//React Imports
import { Link } from "react-router-dom"; // Import Link component from react-router-dom
import { useState } from "react";

const SideNav = ({ setSelectedField, sideNavFields }) => {
  const [open, setOpen] = useState(true);

  // Handle click on a field to expand/collapse the field's options
  const handleClick = (field) => {
    setSelectedField(field); // Set the selected field
    setOpen(!open); // Toggle the open state
  };

  const isDesktop = useMediaQuery("(min-width:600px)"); // Desktop breakpoint

  const menuItems = [
    {
      label: "Add Field",
      icon: <AddCircleOutlineIcon />,
      custom: false,
      link: "/home/addfield",
    },
    {
      label: "Fields",
      icon: <GrassIcon />,
      custom: true,
      link: null,
      customRender: (
        <>
          <ListItem disablePadding onClick={() => setOpen(!open)}>
            <ListItemButton>
              <ListItemIcon style={{ minWidth: "40px" }}>
                <GrassIcon />
              </ListItemIcon>
              {isDesktop && <ListItemText primary="Fields" />}
            </ListItemButton>
            <div style={{ paddingRight: "8px" }}>
              {isDesktop && (open ? <ExpandLess /> : <ExpandMore />)}
            </div>
          </ListItem>

          {/* Field options */}
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {sideNavFields.map((field) => (
                <ListItemButton
                  key={field.id}
                  onClick={() => handleClick(field)}
                  component={Link}
                  to={`/home/${field.id}`}
                  sx={{ pl: 4 }}
                >
                  <ListItemIcon style={{ minWidth: "40px" }}>
                    <CropSquareIcon style={{ minWidth: "40px" }} />
                  </ListItemIcon>
                  <ListItemText primary={field.name} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>
        </>
      ),
    },
    {
      label: "Schedule",
      icon: <AccessTimeIcon />,
      custom: false,
      link: "/home/addSchedule",
    },
    {
      label: "History",
      icon: <HistoryIcon />,
      custom: false,
      link: "/home/history",
    },
    {
      label: "Hardware",
      icon: <DevicesIcon />,
      custom: false,
      link: "hardware",
    },
    {
      label: "Water Sensors",
      icon: <WaterIcon />,
      custom: false,
      link: "water-sensors",
    },
  ];

  return (
    <div className="list-container">
      <List className="listcomponent">
        {menuItems.map((menuItem) => {
          const { label, icon, custom, link, customRender } = menuItem;

          return custom ? (
            customRender
          ) : (
            <ListItem disablePadding>
              <ListItemButton component={Link} to={link}>
                <ListItemIcon style={{ minWidth: "40px" }}>{icon}</ListItemIcon>
                {isDesktop && <ListItemText primary={label} />}
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};

export default SideNav;
